import _ from './underscore.js';

// Start chaining a wrapped Underscore object.
export default function chain(obj) {
  var instance = _(obj);
  instance._chain = true;
  return instance;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/chain.js
// module id = 133
// module chunks = 3